import { Icon } from '@iconify/react'
import dayjs from 'dayjs'
import React, { useState } from 'react'
import { Button, useDisclosure } from '@nextui-org/react'
import countryObject from 'src/data/country_object.json'
import { Link } from 'react-router-dom'

interface IOverview {
  tender: any
}
export default function OverView({ tender }: IOverview) {
  const [showFullDescription, setShowFullDescription] = useState<boolean>(false)
  const { isOpen: isContactPersonModalOpen, onOpenChange: onOpenContactPersonModalChange } = useDisclosure()
  const { isOpen: isContactDepartmentModalOpen, onOpenChange: onOpenContactDepartmentModalChange } = useDisclosure()
  return (
    tender && (
      <div className="p-1 flex flex-1 flex-col h-full">
        <div className="flex flex-row gap-10 pt-4 pb-8">
          <div className="flex flex-col">
            <span className="text-black font-bold text-sm">Date of publication</span>
            <span className="text-black text-sm font-regular">
              {tender.publicationDate ? dayjs(tender.publicationDate).format('DD/MM/YYYY') : ' - '}
            </span>
          </div>
          <div className="flex flex-col">
            <span className="text-black font-bold text-sm">Due date</span>
            <span className="text-black text-sm font-regular">
              {tender.deadline ? dayjs(tender.deadline).format('DD/MM/YYYY') : ' - '}
            </span>
          </div>
          <div className="flex flex-col">
            <span className="text-black font-bold text-sm">Source</span>
            <span className="text-black text-sm font-regular">
              <a href={tender.url} target="_blank" rel="noopener noreferrer"  className="text-xs font-bold">
                {tender.publicationNumber}
              </a>
            </span>
          </div>
          <div className="flex flex-col">
            <span className="text-black font-bold text-sm">Place of the order</span>
            <span className="text-black text-sm font-regular">
              {countryObject?.[tender.country] || tender.country || 'N/A'}
            </span>
          </div>
        </div>
        <div className="flex flex-col flex-1">
          <span className="text-black font-bold text-sm">Project summary</span>
          <span className="text-black text-sm font-regular pb-8">
            {(showFullDescription ? tender.summary : (tender.summary || '').substr(0, 350))
              .split('\n')
              .map((text: string, index: number) => (
                <React.Fragment key={index}>
                  <br />
                  {text}
                </React.Fragment>
              ))}
            {!showFullDescription && tender.summary?.length > 350 ? '...' : ''}
          </span>
          <Button
            variant="light"
            className="p-0 hover:bg-transparent data-[hover=true]:bg-transparent w-fit"
            onPress={() => setShowFullDescription((prev) => !prev)}
          >
            <span className={'text-[#0052CC] flex flex-row items-center font-medium'}>
              <Icon icon={!showFullDescription ? 'lucide:plus' : 'lucide:minus'} color="#0052CC" fontWeight={'700'} />
              View {showFullDescription ? 'less' : 'full'} description
            </span>
          </Button>
        </div>
        <div className="flex flex-row pt-4 pb-10 gap-4">
          <div className="border-1 border-default-300 rounded-md py-4 px-4 min-h-[229px] min-w-[310px] gap-2 flex flex-col">
            <div className="flex flex-row items-center justify-between">
              <span className="text-black font-bold text-sm pb-2">Project contact person</span>
            </div>
            <span
              className={
                tender.buyer
                  ? 'flex flex-row text-sm text-black-500 font-medium items-center gap-2'
                  : 'flex flex-row text-sm text-default-400 font-regular italic items-center gap-2'
              }
            >
              <Icon icon={'lucide:user'} fontWeight={'500'} color={'#09090B'} width={20} />
              {tender?.buyer || 'Not specified yet'}
            </span>
            <span
              className={
                tender.contactPhone
                  ? 'flex flex-row text-sm text-black-500 font-medium items-center gap-2'
                  : 'flex flex-row text-sm text-default-400 font-regular italic items-center gap-2'
              }
            >
              <Icon icon={'lucide:phone'} fontWeight={'500'} color={'#09090B'} width={20} />
              {tender?.contactPhone || 'Not specified yet'}
            </span>
            <span
              className={
                tender.contactEmail
                  ? 'flex flex-row text-sm text-black-500 font-medium items-center gap-2'
                  : 'flex flex-row text-sm text-default-400 font-regular italic items-center gap-2'
              }
            >
              <Icon icon={'lucide:mail'} fontWeight={'500'} color={'#09090B'} width={20} />
              {tender?.contactEmail || 'Not specified yet'}
            </span>
          </div>
        </div>
      </div>
    )
  )
}
